import React from "react";
import useLenis from "@/hooks/useLenis";
import { LangProvider } from "@/context/LangContext";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Ribbon from "@/components/site/Ribbon";
import MenuSection from "@/components/site/MenuSection";
import Drinks from "@/components/site/Drinks";
import Special from "@/components/site/Special";
import Founder from "@/components/site/Founder";
import OrderCTA from "@/components/site/OrderCTA";
import Location from "@/components/site/Location";
import Social from "@/components/site/Social";
import Flyer from "@/components/site/Flyer";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import FloatingWhatsApp from "@/components/site/FloatingWhatsApp";

export default function Site() {
  useLenis();
  return (
    <LangProvider>
      <div className="grain relative bg-[var(--bg)]">
        <Nav />
        <main>
          <Hero />
          <Ribbon />
          <MenuSection />
          <Drinks />
          <Special />
          <Founder />
          <OrderCTA />
          <Location />
          <Social />
          <Flyer />
          <Contact />
          <Testimonials />
        </main>
        <Footer />
        <FloatingWhatsApp />
      </div>
    </LangProvider>
  );
}
